/* eslint-disable import/prefer-default-export */
export const wordsTypes = {
  SET_PHRASE_ARRAY: 'SET_PHRASE_ARRAY',
  SET_ADVERB_ARRAY: 'SET_ADVERB_ARRAY',
  SET_WORD: 'SET_WORD',
  SET_RETURNED_WORD: 'SET_RETURNED_WORD',
  SET_SHORTDEF: 'SET_SHORTDEF',
  SET_PART_OF_SPEECH: 'SET_PART_OF_SPEECH',
  SET_WORD_EXAMPLE: 'SET_WORD_EXAMPLE',
  SET_SYNS: 'SET_SYNS',
  SET_ANTS: 'SET_ANTS',
  SET_WORD_ARRAY: 'SET_WORD_ARRAY',
  SET_NOUN_ARRAY: 'SET_NOUN_ARRAY',
  SET_VERB_ARRAY: 'SET_VERB_ARRAY',
  SET_ADJ_ARRAY: 'SET_ADJ_ARRAY',
  SET_AVAILABLE_WORD_TYPES: 'SET_AVAILABLE_WORD_TYPES',
  RESET_AVAILABLE_WORD_TYPES: 'RESET_AVAILABLE_WORD_TYPES',
  ON_OPEN_SEARCHBAR: 'ON_OPEN_SEARCHBAR',
  ON_TOGGLE_SEARCHBAR: 'ON_TOGGLE_SEARCHBAR',
  ON_CLOSE_SEARCHBAR: 'ON_CLOSE_SEARCHBAR',
};
